import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  NbMenuService,
  NbSidebarComponent,
  NbSidebarService,
} from '@nebular/theme';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar
        #sideBar
        class="menu-sidebar"
        tag="menu-sidebar"
        [state]="
          isNative ? 'collapsed' : windowWith >= 576 ? 'expanded' : 'collapsed'
        "
        [fixed]="isNative ? true : windowWith < 576 ? true : false"
      >
        <ng-content select="nb-menu"></ng-content>
        <ng-content select="nb-menu.sidebar-footer"></ng-content>
      </nb-sidebar>

      <nb-layout-column>
        <div class="overlay" *ngIf="showBackdrop"></div>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer *ngIf="!isNative">
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
    <app-loader></app-loader>
  `,
})
export class OneColumnLayoutComponent implements OnInit {
  isNative: any = Capacitor.isNativePlatform();
  windowWith: any = window.innerWidth;
  showBackdrop: boolean = false;
  @ViewChild('sideBar', { static: false }) sideNav: NbSidebarComponent;

  constructor(
    private nbmenu: NbMenuService,
    private nbsidebar: NbSidebarService,
  ) {}

  ngOnInit(): void {
    this.nbmenu.onItemClick().subscribe((ev) => {
      if (window.innerWidth < 1200 && window.innerWidth >= 576) {
        this.nbsidebar.expand('menu-sidebar');
      } else if (window.innerWidth < 576 || Capacitor.isNativePlatform()) {
        this.nbsidebar.collapse('menu-sidebar');
      }
    });
  }
}
